module.exports = __webpack_public_path__ + "static/img/Advanced-Torso-CT5.b695925c.png";